/**
 * @generated SignedSource<<49d672de0b8e597f28128eb5eb1494d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type RepositoryVisibility = "INTERNAL" | "PRIVATE" | "PUBLIC" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type TabbedTimelineFragment$data = {
  readonly id: string;
  readonly repository: {
    readonly id: string;
    readonly nameWithOwner: string;
    readonly viewerCanPush: boolean;
    readonly visibility: RepositoryVisibility;
  };
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"useConversationTimelineItemsBackFragment" | "useConversationTimelineItemsFrontFragment">;
  readonly " $fragmentType": "TabbedTimelineFragment";
};
export type TabbedTimelineFragment$key = {
  readonly " $data"?: TabbedTimelineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TabbedTimelineFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "itemTypes",
    "variableName": "itemTypes"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itemTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TabbedTimelineFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "visibility",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanPush",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "useConversationTimelineItemsFrontFragment"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "useConversationTimelineItemsBackFragment"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "e14893dab550e469c02df2957e809151";

export default node;
